<div *ngIf="dipseLoaderState$ | async" class="dipse-loader">
  <div>
    <svg svg-theme="" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
         viewBox="0 0 1000 1000">
      <g class="loading-big">
        <path class="loading-circle"
              d="M960,500c0,254.05-205.95,460-460,460S40,754.05,40,500,245.95,40,500,40,960,245.95,960,500"
              style="fill: none;stroke-linecap: round;stroke-linejoin: round;stroke-width: 80px;stroke: #008a00"></path>
      </g>
      <g class="loading-small">
        <path class="loading-circle"
              d="M960,500c0,254.05-205.95,460-460,460S40,754.05,40,500,245.95,40,500,40,960,245.95,960,500"
              style="fill: none;stroke-linecap: round;stroke-linejoin: round;stroke-width: 80px;stroke: #008a00"></path>
      </g>
    </svg>
  </div>
</div>
